export const ScoreConfig = {
  /** Base score per successful block removal */
  baseScore: 10,

  /** Combo multiplier table: index = combo count (0-based) */
  comboMultiplierTable: [1.0, 1.2, 1.5, 2.0, 3.0, 5.0],

  /** Speed factor: faster swipes get bonus. speedFactor = 1 + (speedBonus * normalizedSpeed) */
  speedBonus: 0.5,

  /** Accuracy factor: how centered the remaining tower is. Range [0.5, 1.5] */
  accuracyMin: 0.5,
  accuracyMax: 1.5,

  /** Stability factor: how upright the tower remains. Range [0.5, 1.5] */
  stabilityMin: 0.5,
  stabilityMax: 1.5,

  /** Stage factor: multiplier increases per stage */
  stageFactorBase: 1.0,
  stageFactorIncrement: 0.2,
} as const;
